import { render, staticRenderFns } from "./DiscoverItemsRuler.vue?vue&type=template&id=2502702c&scoped=true&"
import script from "./DiscoverItemsRuler.vue?vue&type=script&lang=js&"
export * from "./DiscoverItemsRuler.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverItemsRuler.vue?vue&type=style&index=0&id=2502702c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2502702c",
  null
  
)

export default component.exports